
import apiClient from './apiClient';

export const getUserStatusList = (params) => apiClient.get('/user_status', { params });
export const createUserStatus = (data) => apiClient.post('/user_status', data);
export const updateUserStatus = (id, data) => apiClient.put(`/user_status/${id}`, data);
export const deleteUserStatus = (id) => apiClient.delete(`/user_status/${id}`);

